import _jsx from "@babel/runtime/helpers/jsx";
import React, { useContext, PureComponent, createContext } from 'react';
const DataIslandContext = /*#__PURE__*/createContext({
  dataIsland: {},
  setDataIsland: () => {},
  getDataIsland: () => {}
});
export class DataIslandProvider extends PureComponent {
  constructor(props) {
    super(props);
    const {
      value
    } = props;
    this.state = {
      dataIsland: value,
      // eslint-disable-next-line react/no-unused-state
      setDataIsland: this.setData.bind(this),
      // eslint-disable-next-line react/no-unused-state
      getDataIsland: this.getData.bind(this)
    };
  }
  setData(data) {
    if (data === void 0) {
      data = {};
    }
    this.setState({
      dataIsland: data
    });
  }
  getData() {
    const {
      dataIsland
    } = this.state;
    return dataIsland;
  }
  render() {
    const {
      children
    } = this.props;
    return /*#__PURE__*/_jsx(DataIslandContext.Provider, {
      value: this.state
    }, void 0, children);
  }
}
export const useDataIsland = () => useContext(DataIslandContext);
export default DataIslandContext;